import { LocationStore } from '@fitness-force/models';

export const LOCATION_STATE: LocationStore = {
  location: {
    ip: '',
    hostname: '',
    city: '',
    region: '',
    country: '',
    loc: "",
    org: '',
    postal: '',
    timezone: '',
  },
};
